import { useState, useEffect,useRef } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';
import { useSelector, useDispatch } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import ManageButtonArea from "./area/manage_btn";
import TodoListArea from "./area/todo_list";

function ViewTodoWordPrintArea(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    todo_pri_val_arr: [],
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const [todo_info_arr, set_todo_info_arr] = useState<any[]>([]);
  let saved_print_option:any=strFunc.get_storage("todo_word_print_option");
  if(saved_print_option){
    saved_print_option=JSON.parse(saved_print_option);
  }
  const [print_options, set_print_options] = useState<any>({
    print_templete: "box",//line
    repeat_cnt: 10,//5,10
    user: user,
    box_opt: {
      row: 10,
      col: 5
    },
    line_opt: {
      row: 15,
    },
    is_print_stu_name: false,
    is_print_word: true,
    is_print_mean: true,
    is_reverse: false,
    ...saved_print_option
  });

  const printRef = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  useEffect(() => {
    get_todo_info_arr_by_ajax({
      todo_pri_val_arr: myProps.todo_pri_val_arr
    });
  }, []);

  const get_todo_info_arr_by_ajax = (inData: any) => {
    let opt_obj = {
      "todo_pri_val_arr": myProps.todo_pri_val_arr,
      "is_reverse": print_options.is_reverse,
      ...inData
    };

    if (strFunc.is_empty(opt_obj.todo_pri_val_arr)) {
      return false;
    }

    let list_form_json = {
      "s_pri_arr": opt_obj.todo_pri_val_arr,
      "order_id": "a_reserve_start_date, a_seq",
      "is_paging": "",
      "s_addon_par_content": "1",
      "s_addon_comp_user": "1",
      "s_addon_mcomp_title": "1",
    };
    if(opt_obj.is_reverse){
      list_form_json["order_id"]="a_reserve_start_date DESC, a_seq";
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/todo/todo/list', list_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_todo_info_arr(response.data["data"]["info_arr"]);
        } else {
          alert("검색 중 오류." + response.data["msg"]);
          props.closePopup();
        }
      });
  };

  return (
    <div>
      <div className='text-center'>
        단어장 프린트 ({todo_info_arr.length}건)
      </div>
      <ManageButtonArea
        print_options={print_options}
        set_print_options={(inData:any)=>{
          set_print_options(inData);
          let save_storage_json={
            print_templete:inData.print_templete,
            repeat_cnt:inData.repeat_cnt,
            is_print_stu_name:inData.is_print_stu_name,
            is_print_word: inData.is_print_word,
            is_print_mean: inData.is_print_mean,
          };
          strFunc.set_storage("todo_word_print_option",JSON.stringify(save_storage_json));
        }}
        get_todo_info_arr_by_ajax={get_todo_info_arr_by_ajax}
        handlePrint={handlePrint}
      ></ManageButtonArea>
      <div ref={printRef} style={{ width: "21cm", margin: "0 auto" }} >
        <TodoListArea
          todo_info_arr={todo_info_arr}
          print_options={print_options}></TodoListArea>
      </div>
    </div>
  );
};
export default ViewTodoWordPrintArea;